import View from './view';
export const Table = View;
